import { SkillEnum } from '@doltech/utils/lib/constants';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ERROR_NOT_SUPPORTED } from '../../question-data-model/constants';
import { DO_TEST_MOBILE_TOPBAR_HEIGHT } from '../../student-do-test/mobile/DoTest/Reading/Header/DoTestHeader';
import { ListeningTestResult } from '../layouts/ListeningTestResult';
import { ReadingTestResult } from '../layouts/ReadingTestResult';
import { TestResultLayoutMobile } from '../layouts/TestResultLayoutMobile';
import { useTestResultStore } from '../model/test-result.hook';

const TestResultLayoutTablet = styled(TestResultLayoutMobile)`
  padding-top: ${DO_TEST_MOBILE_TOPBAR_HEIGHT + 4}px;
  #body-container {
    padding: 16px 24px;
  }

  .dol-question,
  section.section-result-item,
  .explanation-summary-detail section {
    border-radius: 16px;
  }
`;

export const TestResultTablet = observer((props: any) => {
  const store = useTestResultStore();
  if (!store.initialed) return null;

  const currentSection = store?.getCurrentTestSection();
  if (isNil(currentSection)) return null;

  const renderTestResultBySkill = () => {
    switch (currentSection?.skill) {
      case SkillEnum.READING:
        return <ReadingTestResult />;
      case SkillEnum.LISTENING:
        return <ListeningTestResult />;
      default:
        return <div>{`${currentSection.skill} ${ERROR_NOT_SUPPORTED}`}</div>;
    }
  };

  return <TestResultLayoutTablet {...props}>{renderTestResultBySkill()}</TestResultLayoutTablet>;
});
